import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import T from 'common/Table'

const Search = props => (
  <div className={`pv2 bb b--mid-gray flex items-center ${props.className || ''}`}>
    <img className='mr2'
      src='assets/search.png'
      style={{
        height: '16px',
        width: '16px',
      }}
    />
    <input className='input-reset sans-serif silver w-100 pa0 pt1 bn outline-0 norms-14'
      placeholder='Search Position'
      style={{
        height: '21px',
      }}
      onChange={props.onChange}
    />
  </div>
)

const Select = props => (
  <div className={`relative pv2 bb b--mid-gray${props.className ? (' ' + props.className) : ''}`}>
    <select className='input-reset sans-serif silver w-100 pointer outline-0 norms-14 bn br0 bg-transparent'
      style={{
        height: '24px',
      }}
      value={props.value}
      onChange={props.onChange}
    >
      {props.children}
    </select>
    <img className='db absolute pointer-events-none'
      src='assets/triangle.png'
      style={{
        height: '5px',
        right: '8px',
        top: '50%',
        transform: 'translateY(-50%)',
        width: '10px',
      }}
    />
  </div>
)

const Position = ({ data, hideDepartment, hideLocation }) => {
  let lastLine = `${data.department} - ${data.city}`

  if (hideDepartment && hideLocation) {
    lastLine = null
  } else if (hideDepartment) {
    lastLine = data.city
  } else if (hideLocation) {
    lastLine = data.department
  }

  return (
    <a target='_blank' key={data.id} href={data.link} className='db no-underline pt3 pb2 bb b--mid-gray'>
      <p className='ma0 mb2 norms-14 dark-gray'>{data.name}</p>
      {lastLine ? <p className='ma0 norms-12 silver'>{lastLine}</p> : null}
    </a>
  )
}

const PositionRow = ({ data, hideDepartment, hideLocation }) => (
  <T.Row key={data.id}>
    <T.Data>
      <a target='_blank' className='dark-gray no-underline underline-hover' href={data.link}>
        {data.name}
      </a>
    </T.Data>
    {hideDepartment ? null : <T.Data>{data.department}</T.Data>}
    {hideLocation ? null : <T.Data>{data.city}</T.Data>}
  </T.Row>
)

const Arrow = props => (
  props.sorting
    ? (
      <Fragment>
        <img className={`v-mid ml2${props.sortOrder === -1 ? ' dn' : ''}`} src='assets/chevron-down.png' style={{ width: '0.625rem' }} />
        <img className={`v-mid ml2${props.sortOrder === 1 ? ' dn' : ''}`} src='assets/chevron-up.png' style={{ width: '0.625rem' }} />
      </Fragment>
    )
    : null
)

export default class PositionsTable extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    positions: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      city: PropTypes.string,
      department: PropTypes.string,
    })),
    locations: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })),
    departments: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })),
    hideDepartment: PropTypes.bool,
    hideLocation: PropTypes.bool,
    onSearch: PropTypes.func,
    onChangeDepartment: PropTypes.func,
    onChangeLocation: PropTypes.func,
    selectedDepartment: PropTypes.string,
    selectedLocation: PropTypes.string,
    onClickHeader: PropTypes.func,
    sortBy: PropTypes.string,
    sortOrder: PropTypes.number,
  }

  static defaultProps = {
    data: [],
    locations: [],
    departments: [],
    hideDepartment: false,
    hideLocation: false,
    onSearch: () => {},
    onChangeDepartment: () => {},
    onChangeLocation: () => {},
    onClickHeader: () => {},
  }

  componentDidUpdate () {
    const small = document.getElementById(this.props.id + '-small-body')
    const big = document.getElementById(this.props.id + '-big-body')

    small.classList.add('st-dim')
    big.classList.add('st-dim')

    if (this.timeout) {
      window.clearTimeout(this.timeout)
    }

    this.timeout = window.setTimeout(() => {
      small.classList.remove('st-dim')
      big.classList.remove('st-dim')
    }, 300)
  }

  componentWillUnmount () {
    if (this.timeout) {
      window.clearTimeout(this.timeout)
    }
  }

  renderDepartments () {
    return this.props.departments.map(dep =>
      <option key={dep.id} value={dep.id}>{dep.name}</option>
    )
  }

  renderLocations () {
    return this.props.locations.map(loc =>
      <option key={loc.id} value={loc.id}>{loc.name}</option>
    )
  }

  renderSmallFilters () {
    const department = this.props.hideDepartment
      ? null
      : (
        <Select className='mb2'
          onChange={this.props.onChangeDepartment}
          value={this.props.selectedDepartment}
        >
          <option value=''>All Departments</option>
          {this.renderDepartments()}
        </Select>
      )

    const location = this.props.hideLocation
      ? null
      : (
        <Select className='mb2'
          onChange={this.props.onChangeLocation}
          value={this.props.selectedLocation}
        >
          <option value=''>All Locations</option>
          {this.renderLocations()}
        </Select>
      )

    return (
      <div key='small-filters' className='st-mb3 pb3 flex flex-column'>
        <Search className='mb2' onChange={this.props.onSearch} />
        {department}
        {location}
      </div>
    )
  }

  renderSmallTable () {
    const positions = this.props.positions.length > 0
      ? this.props.positions.map(pos => (
        <Position hideDepartment={this.props.hideDepartment}
          key={pos.id}
          data={pos}
        />
      ))
      : <p>No Open Positions</p>

    return (
      <div key='small' className='dn-l' id='smallPositionTable'>
        {this.renderSmallFilters()}
        <div key='small'>
          <div className='st-pb3 norms-20 fw5 dark-gray tl pointer' onClick={() => this.props.onClickHeader('name')}>
            Position
            <Arrow sorting={this.props.sortBy === 'name'} sortOrder={this.props.sortOrder} />
          </div>
          <div id={this.props.id + '-small-body'} className='transition-a'>
            {positions}
          </div>
        </div>
      </div>
    )
  }

  renderBigFilters () {
    const department = this.props.hideDepartment
      ? null
      : (<T.DataNoBorder className='pb4'>
        <Select className='mr3'
          onChange={this.props.onChangeDepartment}
          value={this.props.selectedDepartment}
        >
          <option value=''>All Departments</option>
          {this.renderDepartments()}
        </Select>
      </T.DataNoBorder>
      )

    const location = this.props.hideLocation
      ? null
      : (
        <T.DataNoBorder className='pb4'>
          <Select onChange={this.props.onChangeLocation}
            value={this.props.selectedLocation}
          >
            <option value=''>All Locations</option>
            {this.renderLocations()}
          </Select>
        </T.DataNoBorder>
      )

    return (
      <T.Row>
        <T.DataNoBorder className='pb4'>
          <Search className='mr3' onChange={this.props.onSearch} />
        </T.DataNoBorder>
        {department}
        {location}
      </T.Row>
    )
  }

  renderBigTable () {
    const {
      id,
      positions,
      hideDepartment,
      hideLocation,
      onClickHeader,
      sortBy,
      sortOrder,
    } = this.props

    const pos = positions.length > 0
      ? positions.map(pos => (
        <PositionRow hideDepartment={hideDepartment}
          hideLocation={hideLocation}
          key={pos.id}
          data={pos}
        />
      ))
      : <T.Row><T.Data colSpan='3'><p>No Open Positions</p></T.Data></T.Row>

    let headClassName = 'w-50'

    if (hideDepartment && hideLocation) {
      headClassName = ''
    } else if (hideDepartment || hideLocation) {
      headClassName = 'w-70'
    }

    return (
      <T.Table key='big' className='dn dt-l'>
        <T.Head>
          {this.renderBigFilters()}
          <T.Row>
            <T.Header className={headClassName} sorting={sortBy === 'name'} sortOrder={sortOrder} onClickHeader={() => onClickHeader('name')}>Position</T.Header>
            { hideDepartment ? null : <T.Header sorting={sortBy === 'department'} sortOrder={sortOrder} onClickHeader={() => onClickHeader('department')}>Department</T.Header> }
            { hideLocation ? null : <T.Header sorting={sortBy === 'city'} sortOrder={sortOrder} onClickHeader={() => onClickHeader('city')}>Location</T.Header> }
          </T.Row>
        </T.Head>
        <T.Body id={id + '-big-body'} className='transition-a'>
          {pos}
        </T.Body>
      </T.Table>
    )
  }

  render () {
    return [
      this.renderSmallTable(),
      this.renderBigTable(),
    ]
  }
}
